import {isEmpty, values} from 'lodash';

import {getMatchingStageValueSchemas, getPossibleStageValues} from '../../../stageUtils';
import {nodeWidth, processorStepHeight, stageStepHeight} from './consts';
import {ProcessorDefinition, ProbeProcessor} from '../../../types';

export function getProcessorSize(processor: ProbeProcessor) {
  const stageCount = values(processor.outputs).length;
  return {
    width: nodeWidth,
    height: processorStepHeight + stageCount * stageStepHeight,
  };
}

export function checkConnectorsCompatibility(c1, c2, processorDefinitionsByName: Record<string, ProcessorDefinition>) {
  if (c1.type === c2.type || c1.processor.name === c2.processor.name) return false;
  const [input, output] = c1.type === 'output' ? [c2, c1] : [c1, c2];
  return !isEmpty(getMatchingStageValueSchemas(
    getPossibleStageValues(processorDefinitionsByName[input.processor.name].inputs[input.id]),
    getPossibleStageValues(processorDefinitionsByName[output.processor.name].outputs[output.id]),
  ));
}
